module.exports = __webpack_public_path__ + "2c6c64183d6095d07f58b654b7c5757b.MP3";